import { ReactNode, createContext, useContext } from 'react';
import useFetchPartnerAccounts from '../hooks/useApi/useFetchPartnerAccounts';

import type { FetchPartnerAccountsResponse, PartnerAccountsRequest } from '../hooks/useApi/useFetchPartnerAccounts';

type PartnerAccountsCtx = {
  response: FetchPartnerAccountsResponse | undefined;
  refreshPartnerAccounts: (params?: PartnerAccountsRequest) => Promise<FetchPartnerAccountsResponse>;
  reset: () => void;
};

// Outside a provider there is nothing to fetch and nothing fetched; the rejection is what tells a
// caller that, rather than a hand-built empty response that reads as real data.
export const PartnerAccountsContext = createContext<PartnerAccountsCtx>({
  response: undefined,
  refreshPartnerAccounts: () => Promise.reject(new Error('PartnerAccountsProvider is not mounted')),
  reset: () => {},
});

export const PartnerAccountsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const { response, fetchPartnerAccounts, reset } = useFetchPartnerAccounts();

  return (
    <PartnerAccountsContext.Provider
      value={{
        response,
        refreshPartnerAccounts: fetchPartnerAccounts,
        reset,
      }}
    >
      {children}
    </PartnerAccountsContext.Provider>
  );
};

export const usePartnerAccounts = (): PartnerAccountsCtx => useContext(PartnerAccountsContext);
